/**
 * 引用环境变量配置的变量
 */
export default {
  /**
   * Api 根目录
   */
  ApiRoot: process.env.VUE_APP_API_ROOT,
  ThingjsRoot: process.env.VUE_APP_API_THINGJS,
  HnucmRoot: process.env.VUE_APP_API_HNUCM,
  /**
   * 资源服务根目录（图片，视频等)
   */
  ResRoot: process.env.VUE_APP_API_ROOT,

  SaltCode: 'sdjokewkr;lkl;k;sdfmlkl;k;HNJKJLI;ldrtftyPOlhFDDpo[;UJGTehkL414574hyFTedtFGIIO',

  /**
   * 文件上传的接口路径
   */
  UploadUrl: `${process.env.VUE_APP_API_ROOT}/file`,
  coverPrefix: process.env.VUE_APP_API_COVER_PREFIX,
  // rsa公钥密码
  publicKey: `-----BEGIN PUBLIC KEY-----
  MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAm3+ncgs1WAs82t6JJRl/qOKfkQw5YeDrHjhB0TC4taveQnjJ+r/oGnp1D+Ehpd0xuPL5fJYGd2I5sOBB1BueoJf+iN/gL/sovYnBoPqCKdZb0I+u1wlIr4UAv0NzFN4op6wDk7RPu3PpkVn8oMANGU7yBKFeg9n8Wt1kV+TyMyRH12mymp5a5aO5JvMNznABSTP/gwv9iK4iiHn58V97STy9ajirzNLmIG9WuFe5tSwdlGk2jmShv9W8EQmPfDcJ3jnt304SppZbFUOmy0Rg71zlvobIQC5EvlAyg3BCva7/Ts/D6pDNW82gZxt9Osdiym9KPwGifuiR7QzzhS9utwIDAQAB
    -----END PUBLIC KEY-----`
}
